// extracted by mini-css-extract-plugin
export default {"base":"Search_base__YqY51","input":"Search_input__klILD","focus":"Search_focus__jBdWT"};